module.exports = __webpack_public_path__ + "static/media/ari_cohen.bb068498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/ari_cohen.jpg
// module id = 212
// module chunks = 0